<template>
    <modal title="Report an Incident" width="45" :showModal="showModal" @close-modal="closeModal">
        <div class="flex flex-col" v-loading="loading">
            <p class="my-4">Tell us about this incident:</p>
            <div class="flex flex-wrap items-center">
                <label class="block w-full mb-2">Location:</label>
                <label class="radio-label" for="business-customer">
                    <input type="radio" id="business-customer" value="business" />
                    Use current Location
                    <span></span>
                </label>
                <label class="radio-label ml-4" for="private-customer">
                    <input type="radio" id="private-customer" value="private" />
                    Search
                    <span></span>
                </label>
            </div>

            <div class="w-full mt-3">
                <label class="label">Incident Category</label>
                <el-select filterable placeholder="--Select--">
                    <el-option v-for="catagory in dataCategory" :key="catagory" :label="catagory" :value="catagory">
                    </el-option>
                </el-select>
            </div>

            <div class="w-full mt-2">
                <label class="label">Severity</label>
                <el-select filterable placeholder="--Select--">
                    <el-option v-for="Severity in Severities" :key="Severity" :label="Severity" :value="Severity">
                    </el-option>
                </el-select>
            </div>

            <div class="w-full mt-2">
                <label class="label">Tell us more</label>
                <textarea class="textArea" placeholder="Text Area"></textarea>
            </div>

            <div class="mt-4 mb-3">
                <b>Upload File</b>
                <p class="opacity-50 text-sm">(File accepted: .jpg, .jpeg, .png - Max file size: 2mb)</p>
                <div class="mt-2 select_contaioner">
                    <span class="select_btn cursor-pointer" @click="openFile">
                        <img src="../components//icons/selectIcon.svg" class="mr-2" /> Select file
                        <input class="hidden" type="file" ref="fileinput" id="fileinput"/>
                    </span>
                </div>
            </div>

            <div class="flex justify-between items-center mt-3">
                <p>Submit & Request Assistance</p>
                <button class="button py-2">Submit</button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    props: {
        showModal: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            dataCategory: [
                "Faulty Vehicle", "Accident", "Arrest", "Community Disturbance", "Traffic Delay",
                "Theft", "Robbery"
            ],
            Severities: ["Minor", "Major", "Category"]
        }
    },
    computed: {
        customStyle() {
            return {
                width: '100%',
                padding: '8px 10px',
                borderRadius: '5px',
                border: '1px solid grey'
            }
        },
    },
    methods: {
        openFile(){
            document.querySelector('#fileinput').click()
        },
        closeModal() {
            this.$emit("closeModal");
        },
    },
};
</script>

<style scoped>
.select_contaioner {
    @apply rounded border-gray-200;
    border-width: 2px;
}

.select_btn {
    @apply text-sm bg-secondary-yellow rounded inline-flex px-2 py-2 items-center
}

.textArea {
    @apply bg-gray-100 w-full py-2 px-2 border-2 border-gray-300 rounded-md resize-none h-48
}

.input_field {
    @apply bg-gray-100 w-full py-2 px-2 border-2 border-gray-300 rounded-md;
}

.button {
    background: #fcc210;
    color: var(--primaryblue);
    width: 40%;
    font-weight: 500;
    /* margin-top: 3rem; */
}

.new-address-button {
    text-decoration-line: underline;

    color: #da9601;
}

.radio-label span::after {
    background: #bec4d5;
}
</style>